import { ContractPaymentComponent } from "src/features/CustomerPayment/ContractPaymentComponent"

export const CustomerPayments = () => {
    return (
        <ContractPaymentComponent />
    )
}
